import { useEffect, useRef, useState } from "react";

const DownArrow = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const PlusIcon = ({ className }: { className?: string }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);

interface OrganizationMenuProps {
    currentOrg: string | null;
    organizations: string[];
    onPickOrg: (org: string) => void;
    footerLabel?: string;
    onFooter?: () => void;
    className?: string;
    buttonClassName?: string;
}

const OrganizationMenu = ({
    currentOrg,
    organizations,
    onPickOrg,
    footerLabel,
    onFooter,
    className = "",
    buttonClassName = "",
}: OrganizationMenuProps) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    return (
        <div ref={ref} className={`relative ${className}`}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className={`flex items-center gap-2 ${buttonClassName}`}
            >
                <span className="truncate">{currentOrg || "Select organization"}</span>
                <DownArrow className="h-4 w-4 shrink-0" />
            </button>
            {open && (
                <div className="absolute right-0 z-50 mt-2 min-w-[12rem] overflow-hidden rounded-r10 bg-black90 py-1 shadow-lg">
                    {organizations.map((org) => (
                        <button
                            key={org}
                            type="button"
                            onClick={() => {
                                onPickOrg(org);
                                setOpen(false);
                            }}
                            className={`flex w-full items-center px-4 py-2 text-left text-h5 hover:bg-black80 ${
                                org === currentOrg ? "text-primary" : "text-white"
                            }`}
                        >
                            <span className="truncate">{org}</span>
                        </button>
                    ))}
                    {footerLabel && onFooter && (
                        <>
                            {organizations.length > 0 && (
                                <div className="my-1 border-t border-black80" />
                            )}
                            <button
                                type="button"
                                onClick={() => {
                                    onFooter();
                                    setOpen(false);
                                }}
                                className="flex w-full items-center gap-2 px-4 py-2 text-left text-h5 text-white hover:bg-black80"
                            >
                                <PlusIcon className="h-4 w-4 shrink-0" />
                                {footerLabel}
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default OrganizationMenu;
